/* <fitpod-lang-menu>: header language dropdown (snippets/language-dropdown.liquid).
   Click or tap opens and closes; outside click and Esc close (Esc returns focus to the toggle);
   ArrowDown / ArrowUp move between the options, Home / End jump. Options are submit buttons of Shopify's
   localization form, so choosing one switches the language and returns to the same page. */
class FitpodLangMenu extends HTMLElement {
  connectedCallback() {
    if (this.ready) return;
    this.toggle = this.querySelector("[data-langmenu-toggle]");
    this.list = this.querySelector("[data-langmenu-list]");
    if (!this.toggle || !this.list) return;
    this.ready = true;
    this.options = () => [...this.list.querySelectorAll("button")];
    this.toggle.addEventListener("click", () => (this.isOpen() ? this.close() : this.open(false)));
    this.toggle.addEventListener("keydown", (e) => {
      if (e.key === "ArrowDown" || e.key === "ArrowUp") { e.preventDefault(); this.open(true, e.key === "ArrowUp"); }
    });
    this.list.addEventListener("keydown", (e) => {
      const opts = this.options();
      const i = opts.indexOf(document.activeElement);
      if (e.key === "ArrowDown") { e.preventDefault(); opts[(i + 1) % opts.length].focus(); }
      if (e.key === "ArrowUp") { e.preventDefault(); opts[(i - 1 + opts.length) % opts.length].focus(); }
      if (e.key === "Home") { e.preventDefault(); opts[0].focus(); }
      if (e.key === "End") { e.preventDefault(); opts[opts.length - 1].focus(); }
      if (e.key === "Tab") this.close();
    });
    this.onDocClick = (e) => { if (this.isOpen() && !this.contains(e.target)) this.close(); };
    this.onKey = (e) => { if (e.key === "Escape" && this.isOpen()) { this.close(); this.toggle.focus(); } };
    document.addEventListener("click", this.onDocClick);
    document.addEventListener("keydown", this.onKey);
  }
  isOpen() { return this.toggle.getAttribute("aria-expanded") === "true"; }
  open(focusOption, last) {
    this.list.hidden = false;
    this.toggle.setAttribute("aria-expanded", "true");
    if (focusOption) {
      const opts = this.options();
      const current = opts.find((o) => o.getAttribute("aria-current") === "true");
      (last ? opts[opts.length - 1] : current || opts[0]).focus();
    }
  }
  close() {
    this.list.hidden = true;
    this.toggle.setAttribute("aria-expanded", "false");
  }
  disconnectedCallback() {
    document.removeEventListener("click", this.onDocClick);
    document.removeEventListener("keydown", this.onKey);
  }
}
if (!customElements.get("fitpod-lang-menu")) customElements.define("fitpod-lang-menu", FitpodLangMenu);
